import { useAxios } from '../useAxios'

export interface IBulkFeedPayload {
    feedIds: string[]
    feedName?: string
    connectionIds?: string[]
    publicIdentifiers?: string[]
}

export const useFeedsRequest = () => {
    const { sendRequest } = useAxios()

    const route = '/feeds'


    const getFeeds = (params?: { page?: number, limit?: number }) => {
        return sendRequest({
            slug: 'getFeeds',
            url: `${route}`,
            method: 'GET',
            params,
            displayToast: false
        })
    }

    const bulkAddConnectionsToFeed = (payload: IBulkFeedPayload, displayToast?: boolean) => {
        return sendRequest({
            slug: 'bulkAddConnectionsToFeed',
            url: `${route}/bulk-add`,
            method: 'POST',
            payload,
            displayToast: displayToast ?? false,
            all: true
        })
    }

    const createFeed = (feedName: string, connectionIds?: string[], publicIdentifiers?: string[]) => {
        return sendRequest({
            slug: 'createFeed',
            url: `${route}`,
            method: 'POST',
            payload: { 
                name: feedName,
                ...(connectionIds && connectionIds.length > 0 && { connectionIds }),
                ...(publicIdentifiers && publicIdentifiers.length > 0 && { publicIdentifiers })
            },
            displayToast: false,
            all: true
        })
    }

    const deleteFeed = (feedId: string) => {
        return sendRequest({
            slug: 'deleteFeed',
            url: `${route}/${feedId}`,
            method: 'DELETE',
            displayToast: false,
            all: true
        })
    }

    const renameFeed = (feedId: string, newName: string) => {
        return sendRequest({
            slug: 'renameFeed',
            url: `${route}/${feedId}`,
            method: 'PUT',
            payload: { name: newName },
            displayToast: false,
            all: true
        })
    }

    const getFeedConnections = (feedId: string, params?: { page?: number, limit?: number }) => {
        return sendRequest({
            slug: 'getFeedConnections',
            url: `${route}/${feedId}/connections`,
            method: 'GET',
            params,
            displayToast: false
        })
    }

    const bulkRemoveConnectionsFromFeed = (payload: { feedId: string; connectionIds: string[] }, displayToast?: boolean) => {
        return sendRequest({
            slug: 'bulkRemoveConnectionsFromFeed',
            url: `${route}/bulk-remove`,
            method: 'POST',
            payload,
            displayToast: displayToast ?? false,
            all: true
        })
    }

    return {
        getFeeds,
        bulkAddConnectionsToFeed,
        createFeed,
        bulkRemoveConnectionsFromFeed,
        deleteFeed,
        renameFeed,
        getFeedConnections
    }
}
